export default __webpack_public_path__ + "static/media/tradedesk-logo.44bd67f7.svg";